// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-form {
    position: relative;
    margin: 0;
}




.form-control {
    background: transparent !important;
    border-radius: -20px !important;
    outline: none !important;
    box-shadow: none !important;
    font-weight: 300 !important;
    margin: 3px 0 !important;
}

.form-control:not(textarea) {
    height: 40px !important;
}

.form-control:hover,
.form-control:focus {
    border-color: #1ABC9C !important;

    border-radius: -20px !important;

}

.submit-btnn {
    background: #474559 !important;
    border-radius: 50px !important;
    color: #ffffff !important;
    font-weight: bold;
    border: 0;
    cursor: pointer;
    transition: all 0.4s ease !important;
    margin: 0 !important;
    position: relative;
    top: auto;
    width: 200px!important;
    text-align: center;


}

.lbtn {
    float: left;
}

.rbtn {
    float: right;
}

.submit-btn {
    background: #1ABC9C !important;
    border-radius: 50px !important;
    color: #ffffff !important;
    font-weight: bold !important;
    border: 0 !important;
    cursor: pointer;
    transition: all 0.4s ease;
    margin: 0;
    position: relative;
    top: auto;
    width: 200px !important;
    text-align: center;


}

.submit-btn:hover {
    background: #474559 !important;
}

.submit-btnn:hover {
    background: #1ABC9C !important;
}

.contact-info {
    background: #474559;
    border-radius: 0 0 3px 3px;
    position: relative;
    bottom: 8px;
}

.contact-info p,
.contact-info a {
    color: #f7f3f3;
}

.lnkbtn {
    text-decoration: none;
    color: #ffffff;
    font-weight: bold;

}


.error-input {
    border: 1px solid red !important;
  }
  
  .error-message {
    display: block;
    margin-top: 5px;
    text-align: left;
    font-size: 14px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/register/Register.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;AACb;;;;;AAKA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,gCAAgC;;IAEhC,+BAA+B;;AAEnC;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,yBAAyB;IACzB,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,oCAAoC;IACpC,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,kBAAkB;;;AAGtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,yBAAyB;IACzB,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;;;AAGtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;;AAErB;;;AAGA;IACI,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB","sourcesContent":[".register-form {\r\n    position: relative;\r\n    margin: 0;\r\n}\r\n\r\n\r\n\r\n\r\n.form-control {\r\n    background: transparent !important;\r\n    border-radius: -20px !important;\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n    font-weight: 300 !important;\r\n    margin: 3px 0 !important;\r\n}\r\n\r\n.form-control:not(textarea) {\r\n    height: 40px !important;\r\n}\r\n\r\n.form-control:hover,\r\n.form-control:focus {\r\n    border-color: #1ABC9C !important;\r\n\r\n    border-radius: -20px !important;\r\n\r\n}\r\n\r\n.submit-btnn {\r\n    background: #474559 !important;\r\n    border-radius: 50px !important;\r\n    color: #ffffff !important;\r\n    font-weight: bold;\r\n    border: 0;\r\n    cursor: pointer;\r\n    transition: all 0.4s ease !important;\r\n    margin: 0 !important;\r\n    position: relative;\r\n    top: auto;\r\n    width: 200px!important;\r\n    text-align: center;\r\n\r\n\r\n}\r\n\r\n.lbtn {\r\n    float: left;\r\n}\r\n\r\n.rbtn {\r\n    float: right;\r\n}\r\n\r\n.submit-btn {\r\n    background: #1ABC9C !important;\r\n    border-radius: 50px !important;\r\n    color: #ffffff !important;\r\n    font-weight: bold !important;\r\n    border: 0 !important;\r\n    cursor: pointer;\r\n    transition: all 0.4s ease;\r\n    margin: 0;\r\n    position: relative;\r\n    top: auto;\r\n    width: 200px !important;\r\n    text-align: center;\r\n\r\n\r\n}\r\n\r\n.submit-btn:hover {\r\n    background: #474559 !important;\r\n}\r\n\r\n.submit-btnn:hover {\r\n    background: #1ABC9C !important;\r\n}\r\n\r\n.contact-info {\r\n    background: #474559;\r\n    border-radius: 0 0 3px 3px;\r\n    position: relative;\r\n    bottom: 8px;\r\n}\r\n\r\n.contact-info p,\r\n.contact-info a {\r\n    color: #f7f3f3;\r\n}\r\n\r\n.lnkbtn {\r\n    text-decoration: none;\r\n    color: #ffffff;\r\n    font-weight: bold;\r\n\r\n}\r\n\r\n\r\n.error-input {\r\n    border: 1px solid red !important;\r\n  }\r\n  \r\n  .error-message {\r\n    display: block;\r\n    margin-top: 5px;\r\n    text-align: left;\r\n    font-size: 14px;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
